import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { StepMetadata } from '../../../../pages/DataFeedWizard/types';

export const stepMetadata: StepMetadata = {
  title: 'Review & Upload',
  subtitle: 'Review processed transactions and upload selected rows to Illio',
  icon: <CheckCircleIcon />,
};
